import {useGetAuditLogQuery} from '~/store/rtkQuery';
import {formatDateTimeWithMs} from '~/modules/utils';

const DetailsCell = ({details}: {details: Record<string, unknown> | null}) => {
  if (!details) return <>-</>;
  return (
    <div className="flex flex-col gap-0.5">
      {Object.entries(details).map(([key, value]) => (
        <div key={key}>
          <span className="font-semibold">{key}:</span> {String(value)}
        </div>
      ))}
    </div>
  );
};

export const AuditLogModal = ({
  endpoints,
  onCancel,
}: {
  endpoints: string[];
  onCancel: () => void;
}) => {
  const {data, isLoading, error} = useGetAuditLogQuery({endpoints});

  const logs = data?.logs ?? [];

  return (
    <dialog className="modal modal-open">
      <div className="modal-box w-11/12 max-w-4xl">
        <div className="text-2xl">Logs</div>
        <p className="mt-1 text-sm text-gray-600">
          Most recent {logs.length ? logs.length : ''} admin actions on{' '}
          {endpoints.join(', ')}
        </p>

        <div className="py-4">
          {isLoading && (
            <span className="loading loading-dots loading-md"></span>
          )}

          {logs.length === 0 && !isLoading && !error && (
            <div className="alert alert-info">
              No log entries found for this endpoint.
            </div>
          )}

          {logs.length > 0 && (
            <table className="table">
              <thead>
                <tr>
                  <th>Time</th>
                  <th>Admin</th>
                  <th>Endpoint</th>
                  <th>Details</th>
                </tr>
              </thead>
              <tbody>
                {logs.map(log => (
                  <tr key={`${log.userId}-${log.timestamp}`}>
                    <td className="align-top">
                      {formatDateTimeWithMs(log.timestamp)}
                    </td>
                    <td className="align-top">
                      {log.userEmail ?? log.userId}
                    </td>
                    <td className="align-top">{log.endpoint}</td>
                    <td className="text-xs align-top">
                      <DetailsCell details={log.details} />
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>

        {!!error && (
          <div role="alert" className="alert alert-error">
            <span>{error.message}</span>
          </div>
        )}

        <div className="modal-action">
          <button className="btn" onClick={onCancel}>
            Close
          </button>
        </div>
      </div>
    </dialog>
  );
};
